import { Menu, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import {
  UserOutlined,
  BankOutlined,
  FlagOutlined,
  HomeOutlined,
  ClockCircleFilled,
  SyncOutlined,
  FileSearchOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import SwitchPerfCycleModal from "../modal/SwitchPerfCycleModal";
import { useSelector } from "react-redux";
import moment from "moment";
import { getPluralString } from "../../helpers/wordHelpers";

const paths = [
  { path: "/home", key: "1" },
  { path: "/my-plans", key: "2" },
  { path: "/units", key: "3" },
  { path: "/top-plans", key: "4" },
  { path: "/positions-performance", key: "5" },
  { path: "/individual-perf", key: "6" },
  { path: "/metabase", key: "7" },
];

function DashboardSideMenu(props) {
  const proHeight = document.body.clientHeight;
  const [mainKey, setMainKey] = useState("");
  const [switchModal, setSwitchModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const topPlanState = useSelector((state) => state.topPlanState.value);
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  let curLocation = useLocation();

  useEffect(() => {
    setMainKey("");
    paths.forEach((path) => {
      if (path.path === curLocation.pathname) {
        setMainKey(path.key);
      } else if (curLocation.pathname.split("/")[1] === "top-plans") {
        setMainKey("4");
      } else if (curLocation.pathname.split("/")[1] === "my-plans") {
        setMainKey("2");
      } else if (curLocation.pathname.split("/")[1] === "units") {
        setMainKey("3");
      } else if (
        curLocation.pathname.split("/")[1] === "positions-performance"
      ) {
        setMainKey("5");
      } else if (
        curLocation.pathname.split("/")[1] === "positions-performance"
      ) {
        setMainKey("5");
      }
    });
  }, [curLocation]);

  useEffect(() => {
    if (topPlanState) {
      setLoading(false);
    }
  }, [topPlanState]);

  return (
    <>
      <Menu
        style={{
          height: proHeight - 64,
          overflow: "auto",
        }}
        className="transparent-scroll"
        theme="dark"
        selectedKeys={[mainKey]}
        mode="inline"
      >
        <Menu.Item
          key="0"
          icon={
            props.collapsed && (
              <div onClick={() => setSwitchModal(true)}>
                <ClockCircleFilled />
              </div>
            )
          }
        >
          <div onClick={() => setSwitchModal(true)}>
            <div className=" text-white hover:text-gray-300">
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-sm text-ellipsis overflow-hidden w-32">
                    {perfCycleState?.name || "..."}
                  </div>
                  <div className="text-xs flex items-center">
                    <div
                      className={
                        "w-2 h-2 rounded-full mr-1 " +
                        (perfCycleState?.status === "Active"
                          ? "bg-green-500"
                          : perfCycleState?.status === "Scheduled"
                          ? "bg-orange-500"
                          : "bg-blue-500")
                      }
                    />
                    {perfCycleState?.name
                      ? moment(perfCycleState?.startingOn).format("DD.MM.YY") +
                        " - " +
                        moment(perfCycleState?.endingOn).format("DD.MM.YY")
                      : "..."}
                  </div>
                </div>
                <Tooltip title={"Change cycle"}>
                  <div className="text-blue-500 hover:text-blue-600">
                    <SyncOutlined />
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </Menu.Item>
        <Menu.Item key="7" icon={<DashboardOutlined />}>
          <Link to="/metabase">Dashboard</Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<FileSearchOutlined />}>
          <Link to="/my-plans">My Plans</Link>
        </Menu.Item>
        <Menu.Item key="1" icon={<ClockCircleFilled />}>
          <Link to="/home">Quick View</Link>
        </Menu.Item>
        <div
          className={
            "text-xs text-white mt-3 mb-3" +
            (props.collapsed ? " text-center" : " pl-6")
          }
        >
          perf
          <span style={{ display: props.collapsed ? "none" : "inline" }}>
            ormance
          </span>
        </div>
        <Menu.Item key="4" icon={<FlagOutlined />}>
          <Link to="/top-plans">
            {loading ? "..." : getPluralString(topPlanState) || "Top plans"}
          </Link>
        </Menu.Item>
        <Menu.Item key="3" icon={<BankOutlined />}>
          <Link to="/units">Units</Link>
        </Menu.Item>
        <Menu.Item key="5" icon={<UserOutlined />}>
          <Link to="/positions-performance">Positions</Link>
        </Menu.Item>
      </Menu>
      <SwitchPerfCycleModal
        visible={switchModal}
        handleCancel={() => setSwitchModal(false)}
      />
    </>
  );
}

export default DashboardSideMenu;
